import * as React from 'react';
import { Button } from '~/design-system/elements/Button/Button';
import { Icon } from '~/design-system/elements/Icon/Icon';
import { cn } from '~/lib/utils';

interface MobileOptimizationMessageProps {
  className?: string;
}

export function MobileOptimizationMessage({ className }: MobileOptimizationMessageProps) {
  const handleOpenDesktop = () => {
    // Copy current URL to clipboard for easy access on desktop
    if (typeof window !== 'undefined' && navigator.clipboard) {
      navigator.clipboard.writeText(window.location.href).catch(() => {
        // Fallback: do nothing if clipboard API is not available
      });
    }
    
    // Open current URL in a new tab (user can then use it on desktop)
    window.open(window.location.href, '_blank');
  };

  return (
    <div 
      className={cn("min-h-screen flex items-center justify-center", className)}
      style={{
        padding: 'calc(var(--spacing) * 5)', // 20px
        backgroundColor: 'var(--color-subtle)'
      }}
    >
      <div 
        style={{
          maxWidth: 'var(--container-xs)', // Using proper container token
          width: '100%',
          backgroundColor: 'var(--color-card)',
          borderRadius: 'var(--radius-2xl)',
          boxShadow: 'var(--shadow-lg)',
          border: '1px solid var(--color-border-default)',
          padding: 'calc(var(--spacing) * 5)', // 20px
          textAlign: 'center' as const
        }}
      >
        {/* Icon */}
        <div 
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '20px'
          }}
        >
          <Icon 
            name="global-line" 
            style={{ 
              color: 'var(--color-state-brand)',
              fontSize: '32px',
              width: '32px',
              height: '32px',
              display: 'inline-block',
              lineHeight: '32px'
            }}
          />
        </div>

        {/* Title */}
        <h1 
          style={{
            fontSize: 'var(--text-2xl)',
            lineHeight: 'var(--text-2xl--line-height)',
            fontWeight: 'var(--font-weight-semibold)',
            color: 'var(--color-text-default)',
            marginBottom: '20px',
            letterSpacing: 'var(--tracking-tight)'
          }}
        >
          Better on Desktop
        </h1>

        {/* Description */}
        <p 
          style={{
            fontSize: 'var(--text-base)',
            lineHeight: 'var(--text-base--line-height)',
            fontWeight: 'var(--font-weight-normal)',
            color: 'var(--color-text-muted)',
            marginBottom: '20px',
            letterSpacing: 'var(--tracking-normal)'
          }}
        >
          Deck works best on desktop and tablet devices.
        </p>

        {/* Call-to-action */}
        <Button 
          onClick={handleOpenDesktop}
          variant="default"
          size="lg"
          className="w-full"
          leadIcon="external-link-line"
        >
          Open on Desktop
        </Button>
      </div>
    </div>
  );
}

export default MobileOptimizationMessage; 